import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TicketHolder, TicketHolderForm } from '@products/models/holder.model';
import { InputBase } from '@shared/forms/inputs/input-base.class';

export const HolderActions = createActionGroup({
  source: 'Product Holder',
  events: {
    'Get questionnaire inputs': props<{ eventId: number; ticketPersonIds: number[] }>(),
    'Set questionnaire inputs': (questionnaireInputs: InputBase<any>[]) => ({ questionnaireInputs }),
    'Load ticket holder': (hash: string) => ({ hash }),
    'Set ticket holder': (ticketHolder: TicketHolder) => ({ ticketHolder }),
    'Post ticket holder form ': (ticketHolderForm: TicketHolderForm) => ({ ticketHolderForm }),
    'Set post ticket holder form result': (ticketHolderFormSubmitResult: boolean) => ({ ticketHolderFormSubmitResult }),
    'Download ticket': (hash: string) => ({ hash }),
    'Download mobile ticket': (hash: string) => ({ hash }),
    'Download pass book': (hash: string) => ({ hash }),
    'Set ticket holder inputs': (inputs: InputBase<any>[]) => ({ inputs }),
    'Reset reducer': emptyProps()
  }
});
